import Button from "core/buttons/button/Button";
import _ from "lodash";
import { ACTIONS, ENTITIES } from "constants/constants";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { TableManager } from "components/bo/admin-table/TableManager";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import { useBackupManagerContext } from "api/settings/backup-manager/BackupManagerProvider";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { usePersonContext } from "api/directory/person/PersonProvider";
import { useUserContext } from "api/user/UserProvider";
import {
  backupManagerForm,
  formatPayload,
  formatReceivedBackupManager,
  formatReceivedBackupManagers,
  formatReceivedBackupManagerToEdit,
} from "utils/backupManagerHelper";

const AdminBackupManager = ({ action }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useUserContext();
  const { id } = useParams();
  const { getPersonsByProfile, personsList, getPersonsByIds } =
    usePersonContext();
  const {
    getBackupManagerList,
    getBackupManagerById,
    createBackupManager,
    updateBackupManager,
    deleteBackupManager,
    backupManagerList,
    backupManagerPerId,
  } = useBackupManagerContext();

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    if (!id) getBackupManagerList();
  }, [getBackupManagerList]);

  useEffect(() => {
    if (id) {
      getBackupManagerById(id);
    }
  }, [id]);

  const handleDelete = (backupManagerId) => {
    const deletedBackupManager = backupManagerList.find(
      (e) => e.id === backupManagerId
    );
    setDeleteData(
      formatReceivedBackupManager({
        backupManager: deletedBackupManager,
        personsList,
        lang,
      })
    );
  };

  const handleCreate = (payload) => {
    createBackupManager(formatPayload(payload));
    navigateToParent(navigate, location);
  };

  const handleEdit = (payload) => {
    updateBackupManager(payload.id, formatPayload(payload));
    navigateToParent(navigate, location);
  };

  useEffect(() => {
    if (backupManagerPerId?.id) {
      getPersonsByIds({
        ids: `${backupManagerPerId?.backed_manager_id},${backupManagerPerId?.backup_manager_id}`,
      });
    }
  }, [backupManagerPerId]);

  useEffect(() => {
    if (backupManagerList?.length > 0) {
      const backedManagersIds = _.chain(backupManagerList)
        .map("backed_manager_id")
        .value();
      const backupManagersIds = _.chain(backupManagerList)
        .map("backup_manager_id")
        .value();
      getPersonsByIds({
        ids: _.chain(backedManagersIds)
          .concat(backupManagersIds)
          .uniqWith(_.isEqual)
          .join(",")
          .value(),
      });
    }
  }, [backupManagerList]);

  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.BACKUP_MANAGER}
        entityPerId={formatReceivedBackupManagerToEdit({
          backupManager: backupManagerPerId,
          personsList,
        })}
        formattedEntity={formatReceivedBackupManager({
          backupManager: backupManagerPerId,
          personsList,
          lang,
        })}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        inputs={backupManagerForm({
          personsList,
        })}
        list={formatReceivedBackupManagers({
          personsList,
          backupManagerList,
          lang,
        })}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        search={(search) => {
          if (search.length >= 3)
            getPersonsByProfile({ search, profile: "mgr,gp,dsoc" });
        }}
      />

      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={deleteBackupManager}
          deleteData={deleteData}
          entity={ENTITIES.BACKUP_MANAGER}
        />
      </div>
    </div>
  );
};

export default AdminBackupManager;
